package com.cybersoftsolution.cybersoftsolutionweb.components.buttons

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.styles.PrimaryButtonStyle
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.primaryButtonId
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Button

@Composable
fun CloseButtonX(
    modifier: Modifier = Modifier,
    onClick: () -> Unit

){
    Box(
        modifier = Modifier
            .height(32.px)
            .fillMaxWidth(),

        contentAlignment = Alignment.CenterEnd,
    ) {
        Button(
            attrs = PrimaryButtonStyle.toModifier()
                .id(primaryButtonId)
                .backgroundColor(Theme.PrimaryButtonLight.rgb)
                //.clip(Circle())
                .width(32.px)
                .height(32.px)
                //.padding(6.px)
                .margin(right = 12.px, top = 12.px)
                .borderRadius(25.px)
//                .border(
//                    width = 1.px,
//                    style = LineStyle.Solid,
//                    color = Theme.Primary.rgb
//                )
                .then(modifier)
                .fontWeight(FontWeight.Normal)
                .fontSize(FontSize.Medium)
                .cursor(Cursor.Pointer)
                .onClick { onClick() }
                .toAttrs(),

            ){
            SpanText(
                text = "X",
                modifier = Modifier
                    .color(Colors.Black)
//                    .fontSize(12.px)
            )
        }

    }

}